module.exports = "<!-- <app-header></app-header> -->\r\n<app-dashboard></app-dashboard>\r\n<!-- <app-footer></app-footer> -->"